module.exports = __webpack_public_path__ + "static/card2-520487a53d48942847a33992ebcd4573.png";